var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-thead"},[_c('tr',[(_vm.$parent.$props.showIndex)?_c('th-ex',{staticClass:"head-index-th"},[_vm._v("序号")]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }